import { render } from "./CoachForm.vue?vue&type=template&id=35c6ed43&scoped=true"
import script from "./CoachForm.vue?vue&type=script&lang=js"
export * from "./CoachForm.vue?vue&type=script&lang=js"

import "./CoachForm.vue?vue&type=style&index=0&id=35c6ed43&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-35c6ed43"

export default script